export default __webpack_public_path__ + "static/media/barvy.ee29d04f.png";